<template>
  <div>
    <div v-if="!prompts?.length" class="panel panel-default no-prompts">
      <div class="panel-body">
        <i class="fas fa-circle-plus" aria-hidden="true"></i>
        No prompts added yet.
        <button class="btn btn-primary add-prompt" @click="addNewPrompt">
          Add Prompt <i class="fas fa-plus" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div v-else class="questionnaire-prompt-list panel-body">
        <!-- Have to use the element in prompts for v-model directive otherwise parent elements don't watch
        prompts correctly and update in the expected way -->
        <!-- eslint-disable-next-line vue/valid-v-model -->
        <questionnaire-prompt v-for="(prompt, index) in prompts" v-model="prompts[index]"
          :number="index + 1"
          :response-options="responseOptions"
          :review-options="reviewOptions"
          :ai-features-supported="aiFeaturesSupported"
          @remove="removePrompt(index)"
          @move-up="movePromptUp(index)"
          @move-down="movePromptDown(index)"
          :key="index"
        ></questionnaire-prompt>
        <div class="add-prompt-container">
          <button class="btn btn-primary add-prompt" @click="addNewPrompt">
            Add Prompt <i class="fas fa-plus" aria-hidden="true"></i>
          </button>
        </div>
    </div>
  </div>
</template>

<style scoped>
.questionnaire-prompt-list {
  display: flex;
  flex-direction: column;
  padding: 0;
  gap: 15px;
}

.add-prompt-container {
  text-align: center;
}

.no-prompts {
  margin-top: 15px;
}

.no-prompts .panel-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 15px;
}

.no-prompts .panel-body > i {
  font-size: 2em;
  opacity: 0.5;
}

</style>

<script>
import copyObject from '@utils/copy-object';
import QuestionnairePrompt from './questionnaire-prompt.vue';

export default {
  components: {
    'questionnaire-prompt': QuestionnairePrompt,
  },
  props: {
    modelValue: {
      type: Array,
    },
    responseOptions: {
      type: Array,
    },
    reviewOptions: {
      type: Array,
    },
    aiFeaturesSupported: {
      type: Boolean,
      default: true,
    },
    newPromptDefault: {
      type: Object,
      default: () => ({
        prompt: undefined,
        responseType: undefined,
        reviewType: undefined,
        enableAiFeedback: false,
        aiFeedbackContextPrompt: '',
      }),
    },
  },
  data() {
    return {
      prompts: this.modelValue,
    };
  },
  watch: {
    modelValue() {
      this.prompts = this.modelValue;
    },
    prompts: {
      handler() {
        this.$emit('update:modelValue', this.prompts);
      },
      deep: true,
    },
  },
  computed: {
    orderedPrompts() {
      return this.prompts;
    },
  },
  methods: {
    addNewPrompt() {
      this.prompts.push(copyObject(this.newPromptDefault));
    },
    removePrompt(index) {
      this.prompts.splice(index, 1);
    },
    movePromptUp(index) {
      if (index > 0) {
        const temp = this.prompts[index - 1];
        this.prompts.splice(index - 1, 1, this.prompts[index]);
        this.prompts.splice(index, 1, temp);
      }
    },
    movePromptDown(index) {
      if (index < this.prompts.length - 1) {
        const temp = this.prompts[index + 1];
        this.prompts.splice(index + 1, 1, this.prompts[index]);
        this.prompts.splice(index, 1, temp);
      }
    },
  },
};
</script>
